export const EmptyOrderType = {
  typeId: 0,
  typeName: "",
};
